import { lazy } from 'react'
import serverData from '../utils/server-data'
const DeletionFeedback = lazy(() =>
  import('../modals/dataPrivacy/data-deletion/feedback'),
)
const Deletionemail = lazy(() =>
  import('../modals/dataPrivacy/data-deletion/email'),
)
const DataDeletion = lazy(() =>
  import('../modals/dataPrivacy/data-deletion/introduction'),
)
const DeletionSuccess = lazy(() =>
  import('../modals/dataPrivacy/data-deletion/success'),
)

const PasswordRecoveryHomeScreen = lazy(() =>
  import('../modals/dataPrivacy/password-recovery/HomeScreen'),
)
const Verification = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/verification'),
)
const LinkedAccounts = lazy(() =>
  import('../modals/dataPrivacy/data-deletion/linked-accounts'),
)

const LoggedOutConfirmEmail = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/ConfirmYourEmail'),
)
const LoggedOutDsrForm = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/LoggedOutDsrForm'),
)
const LoggedOutWelcome = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/introduction'),
)
const Status = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/status'),
)
const LoggedOutTrackYourData = lazy(() =>
  import('../modals/dataPrivacy/logged-out-data-access/TrackYourRequest'),
)

const { closeUrl = null, backUrl = null, showBackButton = true } = serverData

function screenMapper() {
  return {
    '/data/dar': {
      view: lazy(() => import('../modals/dataPrivacy/data-access/EdpbDarForm')),
      props: {
        closeUrl,
        domid: 'request_form_modal',
        backUrl,
      },
    },

    '/data/correctionpage': {
      view: lazy(() => import('../modals/dataPrivacy/data-correction/index')),
      props: {
        closeUrl,
        domid: 'correction_page',
        backUrl,
      },
    },

    '/data/correction': {
      //merchant correction page
      view: lazy(() =>
        import('../modals/dataPrivacy/data-correction/merchant-correction'),
      ),
      props: {
        closeUrl,
        domid: 'merchant_correction',
        backUrl,
      },
    },

    '/data/dar/yourrequests': {
      view: lazy(() => import('../modals/dataPrivacy/data-access/DARHistory')),
      props: {
        closeUrl,
        backUrl,
        domid: 'your_requests_modal',
      },
    },

    '/data/dar/2fareturn': {
      view: lazy(() => import('../modals/dataPrivacy/data-access/EdpbDarForm')),
      props: {
        closeUrl,
        redirect: 'authweb',
        domid: 'authweb_request_form_modal',
        backUrl,
      },
    },

    '/data/deletion': {
      view: lazy(() =>
        import('../modals/dataPrivacy/data-deletion/introduction'),
      ),
      props: {
        slides: [
          DataDeletion,
          LinkedAccounts,
          DeletionFeedback,
          Deletionemail,
          DeletionSuccess,
        ],
        closeUrl,
        backUrl,
        domid: 'data_deletion_modal',
      },
    },

    '/data/deletion/2fareturn': {
      view: lazy(() =>
        import('../modals/dataPrivacy/data-deletion/introduction'),
      ),
      props: {
        redirect: 'authweb',
        slides: [
          DataDeletion,
          LinkedAccounts,
          DeletionFeedback,
          Deletionemail,
          DeletionSuccess,
        ],
        position: 3,
        backUrl,
        closeUrl,
        domid: 'authweb_deletion_modal',
      },
    },

    '/cookiePrefs': {
      view: lazy(() => import('./home/CookiePrefsSettings')),
      props: {
        showBackButton: false,
        closeUrl,
        showPPlogo: true,
        backUrl,
        domid: 'cookiePrefsModal',
        hideCloseBtn: false,
        transitionOnClose: false,
      },
    },
    '/showNotice': {
      view: lazy(() => import('./home/NoticeSettings')),
      props: {
        showBackButton: false,
        hideCloseBtn: false,
        transitionOnClose: false,
        backUrl,
        closeUrl,
        showPPlogo: true,
      },
    },
    '/searchPrivacy': {
      view: lazy(() => import('../modals/search-privacy')),
      props: {
        showBackButton,
        backUrl,
        closeUrl,
        noPadding:
          serverData.selectedComponent === 'EUROPE_SIMPLIFIED' ? false : true,
        domid:
          serverData.selectedComponent === 'SIMPLIFIED'
            ? 'search-privacy-simplified'
            : 'search-privacy-granular',
      },
    },
    '/settings/personalization': {
      view: lazy(() => import('../modals/InterestMarketingModal')),
      props: {
        showBackButton: false,
        hideCloseBtn: false,
        closeUrl,
      },
    },
    '/personalization/paypal': {
      view: lazy(() =>
        import('../modals/personalization/PaypalPersonalization'),
      ),
      props: {
        backUrl,
        closeUrl,
      },
    },

    '/personalization/other': {
      view: lazy(() =>
        import('../modals/personalization/OtherPersonalization'),
      ),
      props: {
        backUrl,
        closeUrl,
      },
    },
    '/common/pypl': {
      props: {
        slides: [LoggedOutWelcome, LoggedOutDsrForm, LoggedOutConfirmEmail],
        backUrl,
        closeUrl,
        domid: 'logged_out_modal',
      },
    },
    '/common/pypl/trackrequest': {
      props: {
        slides: [LoggedOutTrackYourData, Status],
        backUrl,
        closeUrl,
        domid: 'data_track_modal',
      },
    },
    '/common/pypl/verification': {
      props: {
        backUrl,
        closeUrl,
        domid: 'data_verify_modal',
        slides: [Verification],
      },
    },
    '/common/password-recovery': {
      props: {
        showBackButton: false,
        backUrl: '',
        closeUrl: '',
        domid: 'password_recovery_modal',
        slides: [PasswordRecoveryHomeScreen],
      },
    },
    // Use this screen mapper to load the full page modal window
  }
}

export default screenMapper
